import Plyr from 'plyr'

let videoConfiguration = {
    /**
     * Component name
     * @type {String}
     */
    name: 'video-element',

    /**
     * Component
     */
    $component: {},

    /** Data
     * @type {Object}
     */
    $data: {
        video: {},
        playButton: {},
        playerTimeline: {},
        isPlay: false
    },

    /**
     * Create components
     * @void
     */
    init () {
        console.log('VIDEO Initialized')

        this.$component = document.querySelectorAll(`.${this.name}`)

        this.initPlayer()
        this.attachEventsHandlers()
    },

    /**
     * Attach event handlers
     * @void
     */
    attachEventsHandlers () {
        this.$data
            .video
            .forEach(
                video => {
                    video.on(
                        'playing',
                        event => {
                            let buttonPlay = event.target.nextElementSibling

                            video.elements.poster.classList.add('uk-hidden')
                            buttonPlay.classList.add('uk-hidden')
                        }
                    )
                }
            )

        this.$component
            .forEach(
                (player, index) => {
                    let buttonPlay = player.querySelector('.play')
                    // const click_ev = document.createEvent("MouseEvent");
                    // click_ev.initEvent("click", false /* bubble */, true /* cancelable */);

                    // buttonPlay.addEventListener(
                    //     'click',
                    //     () => {
                    //         this.$data.video[index].play()
                    //     }
                    // )
                    buttonPlay.addEventListener(
                        'click',
                        () => {
                            this.$data.video[index].play()
                        }
                    )
                }
            )
    },

    initPlayer () {
        const OPTIONS = { controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'] }

        this.$data.video = Array.from(this.$component).map(p => new Plyr(p.querySelector('video'), OPTIONS))
    }
}

export default videoConfiguration
